/**
 * Generated by orval v8.12.2 🍺
 * Do not edit manually.
 * PEXIFY API
 * PEXIFY API contract (FE ↔ BE).
 *
 * **Status:** M0 initial draft (2026-05-21). This contract is FE-shaped during M0/M1/M2 operational
 * simulation phase per `pol-build-sequence`. Backend implementation begins at M3.
 *
 * **Scope (M0):** IQ-1 Pending Updates Queue endpoints + auth placeholder. Other endpoints added
 * as M0/M1/M2 prototype reveals needs.
 *
 * **Permanent architectural invariant:** JSON only (no GraphQL, no SOAP, no XML). See
 * `planning/nodes/policies/decoupled-api.md` for the full invariant + 5 strategic reasons.
 *
 * OpenAPI spec version: 0.1.0-m0-draft
 */

export type MessagingMessageKind = typeof MessagingMessageKind[keyof typeof MessagingMessageKind];


export const MessagingMessageKind = {
  text: 'text',
  internal_note: 'internal_note',
  system: 'system',
} as const;
